export const big5Advantages = [
  `До 100 000 грн кредитного ліміту`,
  `2% кешбеку в супермаркетах та АЗС за кредитні кошти/ 1% за власні кошти`,
  `1% кешбеку на будь-які покупки кредитними чи власними коштами`,
  `До 62 днів пільговий період`,
  `Безкоштовне оформлення та обслуговування`,
]

export const pudraAdvantages = [
  `До 100 000 грн кредитного ліміту`,
  `5% кешбеку на одяг та взуття за кредитні кошти / 1% за власні кошти`,
  `3% кешбеку на косметику, парфумерію, б’юті сферу та аптеки за крeдитні кошти/ 1% за власні кошти`,
  `До 62 днів пільговий період`,
  `Безкоштовне оформлення та обслуговування`,
]
